// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialShareBar_root__XwzaA","anchor":"SocialShareBar_anchor__N-xz6","facebook":"SocialShareBar_facebook__2Sei9","twitter":"SocialShareBar_twitter__3iP5_"};